import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Modal from '../components/UI/Modal';

const IND_STATES = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar','Chandigarh','Dadra and Nagar Haveli','Daman and Diu','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'];

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', contact_person: '', email: '', phone: '', gstin: '', address: '', city: '', state: '', pincode: '', payment_terms: '', status: 'active' });

  const fetch = async () => {
    try {
      setLoading(true);
      const res = await api.get('/vendors/list.php');
      if (res.data.success) setVendors(res.data.data || []);
      else setError(res.data.message);
    } catch (e) { setError('Failed to load vendors'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetch(); }, []);

  const openCreate = () => {
    setEditing(null);
    setForm({ name: '', contact_person: '', email: '', phone: '', gstin: '', address: '', city: '', state: '', pincode: '', payment_terms: '', status: 'active' });
    setShowForm(true);
  };

  const openEdit = (v) => {
    setEditing(v);
    setForm({ name: v.name || '', contact_person: v.contact_person || '', email: v.email || '', phone: v.phone || '', gstin: v.gstin || '', address: v.address || '', city: v.city || '', state: v.state || '', pincode: v.pincode || '', payment_terms: v.payment_terms || '', status: v.status || 'active' });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) { await api.post('/vendors/update.php', { id: editing.id, ...form }); }
      else { await api.post('/vendors/create.php', form); }
      setShowForm(false);
      fetch();
    } catch (e) { setError('Failed to save vendor'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this vendor?')) return;
    try { await api.post('/vendors/delete.php', { id }); fetch(); }
    catch (e) { setError('Failed to delete vendor'); }
  };

  if (loading) return <div className="text-center py-20 text-gray-600 dark:text-gray-400">Loading...</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-800 dark:text-white">Vendors</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">Manage suppliers: {vendors.length} vendors</p>
        </div>
        <button onClick={openCreate} className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors">Add Vendor</button>
      </div>

      {error && <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 text-red-700 dark:text-red-400 px-4 py-3 rounded-lg">{error}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {vendors.length === 0 ? (
          <div className="col-span-full text-center py-12 text-gray-500 dark:text-gray-400">No vendors added.</div>
        ) : vendors.map(v => (
          <div key={v.id} className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-lg font-semibold text-gray-800 dark:text-white">{v.name}</h3>
              <span className={`px-2 py-1 text-xs font-medium rounded-full ${v.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>{v.status}</span>
            </div>
            {v.contact_person && <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Contact: {v.contact_person}</p>}
            <div className="text-sm text-gray-600 dark:text-gray-400 space-y-1">
              {v.email && <p>{v.email}</p>}
              {v.phone && <p>{v.phone}</p>}
              {v.gstin && <p className="font-mono text-xs">GST: {v.gstin}</p>}
              <p className="text-xs text-gray-400">{v.city}{v.city && v.state ? ', ' : ''}{v.state}</p>
              {v.payment_terms && <p className="text-xs font-medium text-primary-600">Terms: {v.payment_terms}</p>}
            </div>
            <div className="flex gap-2 pt-4 mt-4 border-t border-gray-100 dark:border-gray-700">
              <button onClick={() => openEdit(v)} className="text-sm text-primary-600 hover:text-primary-900 dark:hover:text-primary-400">Edit</button>
              <button onClick={() => handleDelete(v.id)} className="text-sm text-red-600 hover:text-red-900 dark:hover:text-red-400">Delete</button>
            </div>
          </div>
        ))}
      </div>

      <Modal isOpen={showForm} onClose={() => setShowForm(false)} title={editing ? 'Edit Vendor' : 'Add Vendor'}>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2"><label className="block text-sm font-medium mb-1">Vendor Name *</label><input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" required /></div>
            <div><label className="block text-sm font-medium mb-1">Contact Person</label><input type="text" value={form.contact_person} onChange={e => setForm({...form, contact_person: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" /></div>
            <div><label className="block text-sm font-medium mb-1">Email</label><input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" /></div>
            <div><label className="block text-sm font-medium mb-1">Phone</label><input type="text" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" /></div>
            <div><label className="block text-sm font-medium mb-1">GSTIN</label><input type="text" value={form.gstin} onChange={e => setForm({...form, gstin: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" /></div>
            <div><label className="block text-sm font-medium mb-1">City</label><input type="text" value={form.city} onChange={e => setForm({...form, city: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" /></div>
            <div><label className="block text-sm font-medium mb-1">State</label>
              <select value={form.state} onChange={e => setForm({...form, state: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500">
                <option value="">Select</option>
                {IND_STATES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div><label className="block text-sm font-medium mb-1">Pincode</label><input type="text" value={form.pincode} onChange={e => setForm({...form, pincode: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500" /></div>
            <div><label className="block text-sm font-medium mb-1">Payment Terms</label>
              <select value={form.payment_terms} onChange={e => setForm({...form, payment_terms: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500">
                <option value="">Select</option>
                <option value="Advance">Advance</option>
                <option value="Net 7">Net 7</option>
                <option value="Net 15">Net 15</option>
                <option value="Net 30">Net 30</option>
                <option value="Net 45">Net 45</option>
                <option value="Net 60">Net 60</option>
              </select>
            </div>
            <div><label className="block text-sm font-medium mb-1">Status</label>
              <select value={form.status} onChange={e => setForm({...form, status: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="md:col-span-2"><label className="block text-sm font-medium mb-1">Address</label><textarea value={form.address} onChange={e => setForm({...form, address: e.target.value})} rows="2" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"></textarea></div>
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 border border-gray-300 rounded-lg">Cancel</button>
            <button type="submit" className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg">{editing ? 'Update' : 'Create'} Vendor</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Vendors;
